import { action, computed } from 'mobx'
import { type WorkspaceApplicant } from '@/features/admin/staffing/WorkspaceApplicant'
import { type ApplicantManagementPanelViewModel } from './ApplicantManagementPanelViewModel'

/**
 * A row in the applicant management table.
 */
export class WorkspaceApplicantItemViewModel {
  constructor(
    readonly applicant: WorkspaceApplicant,
    private readonly _panelVm: ApplicantManagementPanelViewModel,
  ) {}

  /**
   * Whether the applicant is selected for bulk actions.
   */
  @computed
  get isSelected() {
    return this._panelVm.isSelected(this.applicant)
  }

  /**
   * Whether the applicant can be invited to the posting.
   */
  @computed
  get canInvite() {
    return this._panelVm.canInvite(this.applicant)
  }

  /**
   * Whether the applicant's invitation can be rescinded.
   */
  @computed
  get canRescindInvitation() {
    return this._panelVm.canRescindInvitation(this.applicant)
  }

  /**
   * Toggles whether the applicant is selected for bulk actions.
   */
  @action.bound
  toggleSelected() {
    this._panelVm.toggleApplicant(this.applicant)
  }

  /**
   * Invites the applicant to the posting.
   */
  @action.bound
  invite() {
    return this._panelVm.inviteApplicant(this.applicant)
  }

  /**
   * Rescinds the applicant's invitation.
   */
  @action.bound
  rescindInvitation() {
    return this._panelVm.rescindInvitation(this.applicant)
  }
}
